module.exports = __webpack_public_path__ + "img/bg_04.5466133e.jpg";